import React, { useEffect } from "react";
import { Button } from "@mui/material";
export default function MetricGuideControls({ steps, session, onChange, en }) {
  const t = (d, e) => (en ? e : d),
    current = Math.min(session.index || 0, steps.length - 1);
  const move = (i) =>
    onChange({
      ...session,
      index: Math.max(0, Math.min(steps.length - 1, i)),
      playing: false,
    });
  useEffect(() => {
    if (!session.playing || !session.active || session.mode === "edit") return;
    const timer = setTimeout(
      () =>
        onChange({
          ...session,
          index: Math.min(current + 1, steps.length - 1),
          playing: current < steps.length - 1,
        }),
      session.fast ? 6000 : 16000
    );
    return () => clearTimeout(timer);
  }, [session, steps.length, current, onChange]);
  return (
    <section
      className="metric-guide-controls"
      aria-label={t("Führung", "Guide")}
    >
      <div>
        {["explain", "edit"].map((mode) => (
          <Button
            key={mode}
            variant={
              session.active && session.mode === mode ? "contained" : "outlined"
            }
            onClick={() =>
              onChange({ ...session, active: true, mode, playing: false })
            }
          >
            {mode === "explain"
              ? t("1 · Verstehen und einordnen", "1 · Understand and compare")
              : t("2 · Bewusst anpassen", "2 · Adjust deliberately")}
          </Button>
        ))}
        <Button
          onClick={() =>
            onChange({ ...session, active: !session.active, playing: false })
          }
        >
          {session.active
            ? t("Unterbrechen · freie Übersicht", "Pause · free overview")
            : t("Führung fortsetzen", "Resume guide")}
        </Button>
      </div>
      {session.active && (
        <>
          <label>
            {t("Abschnitt", "Section")}{" "}
            <select
              aria-label={t("Schritt auswählen", "Choose step")}
              value={current}
              onChange={(e) => move(+e.target.value)}
            >
              {steps.map((s, i) => (
                <option key={s.id} value={i}>
                  {i + 1}.{" "}
                  {s.model === "result"
                    ? t("Ergebnis", "Results")
                    : t("Statistik", "Statistics")}{" "}
                  · {s.title}
                </option>
              ))}
            </select>
          </label>
          <span>
            {" "}
            {current + 1}/{steps.length}{" "}
          </span>
          <Button disabled={!current} onClick={() => move(current - 1)}>
            {t("Zurück", "Back")}
          </Button>
          <Button
            disabled={current === steps.length - 1}
            onClick={() => move(current + 1)}
          >
            {t("Weiter", "Next")}
          </Button>
          <Button
            disabled={current === steps.length - 1}
            onClick={() => move(current + 1)}
          >
            {session.mode === "edit"
              ? t("Unverändert lassen · weiter", "Keep unchanged · next")
              : t("Überspringen", "Skip")}
          </Button>
          <label>
            <input
              type="checkbox"
              checked={!!session.compact}
              onChange={(e) =>
                onChange({ ...session, compact: e.target.checked })
              }
            />
            {t("Kompakte Erklärung", "Compact explanation")}
          </label>
          {session.mode === "explain" && (
            <>
              <Button
                onClick={() =>
                  onChange({ ...session, playing: !session.playing })
                }
              >
                {session.playing
                  ? t("Pause", "Pause")
                  : t("Automatisch weiter", "Auto advance")}
              </Button>
              <label>
                <input
                  type="checkbox"
                  checked={!!session.fast}
                  onChange={(e) =>
                    onChange({ ...session, fast: e.target.checked })
                  }
                />
                {t("Beschleunigt", "Faster")}
              </label>
            </>
          )}
          <p>
            {session.mode === "explain"
              ? t(
                  "Dieser Durchlauf erklärt und verändert keine Einstellungen.",
                  "This pass explains without changing settings."
                )
              : t(
                  "Änderungen sammeln → Vorschau unten prüfen → Änderungen speichern. Erst Speichern aktiviert sie.",
                  "Collect changes → inspect preview below → save changes. Only saving activates them."
                )}
          </p>
        </>
      )}
    </section>
  );
}
